import { render, staticRenderFns } from "./spendingState.vue.html?vue&type=template&id=289bacb8&"
import script from "./spendingState.ts?vue&type=script&lang=ts&"
export * from "./spendingState.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports